import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import OtherPriceInputFormStyle from './css/OtherPriceInputFormStyle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function OtherPriceInputForm(props) {
  const otherPriceRef = useRef(null)
  const [invoiceParticular, setInvoiceParticular] = props.invoiceParticular
  const [currentItemUnitPrices, setCurrentItemUnitPrices] = props.currentItemUnitPrices
  const [otherPrice, setOtherPrice] = useState('')
  const modalFormContainer = document.getElementById('modal-form-container')

  useEffect(() => {
    otherPriceRef.current.focus()
    return(() => {
      if ((!invoiceParticular.unit_price) && (!otherPrice)) {
        // Setting unit_price to 0 or any number that does not exist will
        // automatically select the first element on the list (unit_price)
        setInvoiceParticular({ ...invoiceParticular, unit_price: 0})
      }
    })
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otherPrice])

  const onClickOkButton = (e) => {
    if (!isNaN(otherPrice) && (otherPrice)) {
      setInvoiceParticular({ ...invoiceParticular, unit_price: parseFloat(otherPrice) })
      // If the price does not exist on the unit prices list yet only then add it
      // I used == to avoid strict comparison
      if (!currentItemUnitPrices.find(price => price === parseFloat(otherPrice)))
        setCurrentItemUnitPrices([ ...currentItemUnitPrices.filter(item => item !== 'Other price...'), otherPrice, 'Other price...' ])
    }
    onClickCloseButton()
  }

  const onClickCloseButton = (e) => ReactDOM.unmountComponentAtNode(modalFormContainer)

  const onKeyDown = (e) => {
    if (e.key === 'Enter') onClickOkButton()
    if (e.key === 'Escape') onClickCloseButton()
  }

  return (
    <React.Fragment>
      <div id='other-price-form'>
        <input
          ref={otherPriceRef}
          id='other-price'
          name='other_price'
          className='top-anchor'
          type='number'
          value={otherPrice}
          min='0'
          onChange={ (e) => setOtherPrice(e.target.value) }
          onKeyDown={onKeyDown}
        />
        <div className="button-unit">
          <button
            id="ok-button"
            className="pospro-action-btn"
            type="button"
            onClick={onClickOkButton}>
            <FontAwesomeIcon icon='save'/> &nbsp;Ok
          </button>
          <button
            id="close-button"
            className="pospro-action-btn bottom-anchor"
            type="button"
            onClick={onClickCloseButton}>
            <FontAwesomeIcon icon='times'/>&nbsp;Close
          </button>
        </div>
      </div>
      <OtherPriceInputFormStyle />
    </React.Fragment>
  )
}

export default React.memo(OtherPriceInputForm)
